<template>
  <div class="container">
    <!-- <p>{{ recentOrders }}</p> -->
    <table class="table table-sm table-bordered table-responsive table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Date Submitted</th>
          <th scope="col">Card Number</th>
          <th scope="col">Ship Date 1</th>
          <th scope="col">Frog Preference (3LNG)</th>
          <th scope="col">District</th>
          <th scope="col">Building</th>
          <th scope="col">Teacher</th>
          <th scope="col">Shipping Address</th>
          <th scope="col">City</th>
          <th scope="col">State</th>
          <th scope="col">Zip Code</th>
          <th scope="col">Phone Number</th>
          <th scope="col">Email</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="card in recentOrders">
            <td>{{ card.dateSubmitted }}</td>
            <td>{{ card.cardNumber }}</td>
            <td>{{ card.shipDate01 }}</td>
            <td>{{ card.frogPreference }}</td>
            <td>{{ card.district }}</td>
            <td>{{ card.building }}</td>
            <td>{{ card.teacher }}</td>
            <td>{{ card.shippingAddress }}</td>
            <td>{{ card.city }}</td>
            <td>{{ card.state }}</td>
            <td>{{ card.zipCode }}</td>
            <td>{{ card.phone }}</td>
            <td>{{ card.email }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const fb = require('./../firebase/firebase')
import moment from 'moment'
export default {
  data() {
    return {
      orgCardOrders: [],
      dateToCompare: '2023-06-30',
      recentOrders: []
    }
  },
  methods: {
    sortOrgCardOrders() {
      return this.orgCardOrders.sort((a, b) => (a.dateSubmitted.split('-') > b.dateSubmitted.split('-')) - (a.dateSubmitted.split('-') < b.dateSubmitted.split('-'))).reverse()
    },
    removeOldOrgCardOrders() {
      this.orgCardOrders.forEach((element) => {
        if (element.cardNumber != null && element.dateSubmitted.split('-') > this.dateToCompare.split('-')) {
          this.recentOrders.push(element)
          console.log(element.dateSubmitted)
        } else {
          console.log(element, "not greater...")
        }
      })
    }
  },
  mounted() {
    fb.orgCardOrdersCollection.get().then((snapshot) => {
      snapshot.forEach((doc) => {
        this.orgCardOrders.push({
          building: doc.data().building,
          cardNumber: doc.data().cardNumber,
          city: doc.data().city,
          dateSubmitted: moment(doc.data().dateSubmitted).format().split('T') [0],
          district: doc.data().district,
          email: doc.data().email,
          kitId: doc.data().kitId,
          phone: doc.data().phone,
          shipDate01: doc.data().shipDate01,
          frogPreference: doc.data().frogPreference,
          shippingAddress: doc.data().shippingAddress,
          state: doc.data().state,
          teacher: doc.data().teacher,
          zipCode: doc.data().zipCode
        })
      })
    }).then(() => {
      this.sortOrgCardOrders()
      // console.log(this.orgCardOrders)
    }).then(() => {
      console.log('removing')
      this.removeOldOrgCardOrders()
    }).catch((err) => {
      console.log('Error: ', err)
    })
  }
}
</script>

<style lang="css">
</style>
